import React, { useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import { RiMapPin2Line } from 'react-icons/ri'

import './index.css'
import { MdDirectionsCar, MdReport } from 'react-icons/md';
import RouteDetails from './RouteDetails';

import sweetalert from 'sweetalert'


function RoutesList({ data, callbackRoutes, callbackDevices, callbackReports }) {
  const _id = useRef(null);

  const columns = [
    {
      name: 'Status',
      selector: 'status',
      cell: (row) => {
        switch (row.status) {
          case 0:
            return (
              <span className="status-travel-notStarted">
                Não iniciada
              </span>
            )
          case 1:
            return (
              <span className="status-travel-pending">
                Em andamento
              </span>
            )
          case 2:
            return (
              <span className="status-travel-finalized">
                Finalizada
              </span>
            )
          case 3:
            return (
              <span className="status-travel-paused">
                Pausada
              </span>
            )
          default:
            break;
        }
      },
      sortable: true,
      center: true,
      width: '12%'
    },
    {
      name: 'Responsável',
      selector: 'user.name',
      sortable: true,
      width: '15%'
    },
    {
      name: 'Destino',
      selector: 'destiny.address',
      sortable: true,
      width: '32%'
    },
    {
      name: '',
      cell: (row) => (
        <Row>
          <button className="map-address-button" style={{ width: '90px',marginRight: '5px' }} onClick={async (e) => {
            onClickRoute(row);
          }}>
            Trajeto
            <RiMapPin2Line />
          </button>
          <button className="edit-address-button" style={{ width: '100px', mmarginRight: '5px' }} onClick={() => {
            callbackDevices(row, 'devices')
          }}>
            Dispositivos
						<MdDirectionsCar />
          </button>
          <button className="report-address-button" style={{ width: '90px' }} onClick={() => {
            onClickReport(row);
          }}>
            Relatórios
						<MdReport />
          </button>
        </Row>
      ),
      sortable: true,
      width: '30%'
    },
  ];

  const onClickRoute = async (row) => {
    _id.current = row._id;
    sweetalert('Aguarde..', 'Carregando rota...', 'info');
    await callbackRoutes(row)
    sweetalert.close();
  }

  const onClickReport = async (row) => {
    _id.current = row._id;
    await callbackReports(row);
  };

  const conditionalRowStyles = [
    {
      when: row => row._id === _id.current,
      style: {
        backgroundColor: '#03989E',
        color: 'white',
      },
    },
  ];

  const seachData = {
    data,
    columns
  }

  return (
    <div className="container-fluid">
      <DataTableExtensions
        {...seachData}
        filterPlaceholder="Buscar..."
        print={false}>
        <DataTable
          columns={columns}
          data={data}
          pagination={true}
          conditionalRowStyles={conditionalRowStyles}
          expandableRows
          responsive
          expandableRowsComponent={
            <RouteDetails
              data={data} />
          }
          noDataComponent={
            <span>Nenhum registro de viagem encontrado</span>
          }
          selectableRowsHighlight={true}
          style={{
            width: '100%'
          }}
        />
      </DataTableExtensions>
    </div>
  );

}

export default RoutesList;